/* Gợi ý tức thì cho ô tìm kiếm ở header.

   LÝ DO LÀM CÁI NÀY (đo được, không phải cho đẹp):
   Trang /search của Shopify dò cả phần MÔ TẢ sản phẩm, nên gõ "Lock" ra 48 kết
   quả mà đầu bảng là lò vi sóng, bếp từ, cây nước — vì mô tả mấy món đó có
   "khóa trẻ em" (Shopify khớp lock ↔ khóa). Trong khi endpoint gợi ý
   /search/suggest.json với cùng từ đó lại trả về ĐÚNG đồ Lock&Lock:
   chảo, bình giữ nhiệt, nồi cơm. Nên đưa khách vào thẳng sản phẩm từ dropdown
   là đường ngắn nhất, khỏi phải đi qua trang search.

   Còn xếp lại lần nữa ở phía mình: món nào có từ khoá NGAY TRONG TÊN thì lên
   trước. Khách gõ "philips" thì muốn thấy tên có Philips, không phải món chỉ
   nhắc tới Philips ở đâu đó.
*/
(function () {
  'use strict';

  var MIN = 2;        // dưới 2 ký tự thì gõ gì cũng ra, không đáng gọi
  var DEBOUNCE = 220; // đủ để người gõ xong một từ
  var LIMIT = 6;

  // Bỏ dấu để so khớp: khách gõ "ban ui" vẫn phải khớp "Bàn ủi"
  function fold(s) {
    return (s || '').toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/đ/g, 'd');
  }

  /* suggest.json trả price là chuỗi ĐỒNG chứ không phải xu.
     Đối chiếu trên sản phẩm thật: suggest "299000" ↔ /products/x.js 29900000.
     Nên chỉ cần chấm phân cách nghìn, KHÔNG chia 100 (chia là ra 2.990₫). */
  function money(v) {
    var n = parseInt(String(v).replace(/[^\d]/g, ''), 10);
    if (!isFinite(n)) return '';
    try { return new Intl.NumberFormat('vi-VN').format(n) + '₫'; }
    catch (e) { return n.toLocaleString('vi-VN') + '₫'; }
  }

  function setup(form) {
    if (form.dataset.egrSuggestReady === '1') return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    form.dataset.egrSuggestReady = '1';

    var box = document.createElement('div');
    box.className = 'egr-sg';
    box.setAttribute('role', 'listbox');
    box.hidden = true;
    form.appendChild(box);

    var timer, ctrl, items = [], cursor = -1, lastQ = '';

    function close() {
      box.hidden = true;
      cursor = -1;
      input.setAttribute('aria-expanded', 'false');
    }

    function open() {
      box.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function highlight() {
      var links = box.querySelectorAll('.egr-sg__item');
      links.forEach(function (a, i) { a.classList.toggle('is-cur', i === cursor); });
      if (cursor >= 0 && links[cursor]) links[cursor].scrollIntoView({ block: 'nearest' });
    }

    /* Xếp lại: đếm số từ khoá xuất hiện trong TÊN sản phẩm.
       Khớp cả cụm liền nhau thì cộng thêm điểm — "bàn ủi" phải hơn món chỉ
       chứa lẻ tẻ "bàn" ở đâu đó. */
    function rank(products, q) {
      var fq = fold(q);
      var words = fq.split(/\s+/).filter(function (w) { return w.length > 1; });
      return products.map(function (p) {
        var ft = fold(p.title);
        var hit = words.filter(function (w) { return ft.indexOf(w) >= 0; }).length;
        var score = hit * 10;
        if (ft.indexOf(fq) >= 0) score += 25;   // khớp nguyên cụm
        if (ft.indexOf(fq) === 0) score += 10;  // khớp ngay đầu tên
        return { p: p, score: score, hit: hit };
      }).sort(function (a, b) { return b.score - a.score; });
    }

    function render(products, q) {
      var ranked = rank(products, q);
      if (!ranked.length) {
        box.innerHTML =
          '<div class="egr-sg__empty">Không có sản phẩm nào khớp <b>' + esc(q) + '</b>' +
          '<span>Nhấn Enter để tìm rộng hơn</span></div>';
        items = [];
        open();
        return;
      }
      var html = '';
      ranked.forEach(function (r) {
        var p = r.p;
        // esc() cho CẢ url/ảnh: dữ liệu từ API của shop chứ không phải người
        // dùng nhập, nhưng chèn thẳng vào thuộc tính thì vẫn phải chặn dấu "
        var img = p.featured_image && p.featured_image.url
          ? '<img src="' + esc(p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_80x$1$2')) + '" alt="" loading="lazy" width="40" height="40">'
          // Chưa có ảnh: vẽ đúng icon của khung giữ chỗ (snippet egr-noimage)
          // để ô thumb không trơ một mảng xám vô nghĩa
          : '<span class="egr-sg__noimg">' +
            '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2.6" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<rect x="6" y="9" width="36" height="30" rx="4"/><circle cx="17" cy="20" r="3.4"/>' +
            '<path d="M8 33l9.5-9.5a3 3 0 0 1 4.2 0L31 33"/>' +
            '<path d="M28 30l4.4-4.4a3 3 0 0 1 4.2 0L42 30"/></svg></span>';
        html += '<a class="egr-sg__item" role="option" href="' + esc(p.url) + '">' +
          '<span class="egr-sg__thumb">' + img + '</span>' +
          '<span class="egr-sg__txt">' +
            '<span class="egr-sg__name">' + esc(p.title) + '</span>' +
            (p.price ? '<span class="egr-sg__price">' + esc(money(p.price)) + '</span>' : '') +
          '</span></a>';
      });
      html += '<a class="egr-sg__all" href="/search?q=' + encodeURIComponent(q) + '&type=product">' +
        'Xem tất cả kết quả cho “' + esc(q) + '” ›</a>';
      box.innerHTML = html;
      items = Array.prototype.slice.call(box.querySelectorAll('.egr-sg__item, .egr-sg__all'));
      cursor = -1;
      open();
    }

    function esc(s) {
      return String(s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    function fetchNow(q) {
      if (ctrl) ctrl.abort();
      ctrl = ('AbortController' in window) ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=' + LIMIT +
        '&resources[options][unavailable_products]=last';
      fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (j) {
          if (input.value.trim() !== q) return;       // người dùng đã gõ tiếp
          var list = (j.resources && j.resources.results && j.resources.results.products) || [];
          render(list, q);
        })
        .catch(function (e) {
          if (e && e.name === 'AbortError') return;
          close();                                    // lỗi mạng thì im lặng, form vẫn submit được
        });
    }

    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-expanded', 'false');

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < MIN) { close(); return; }
      if (q === lastQ && !box.hidden) return;
      lastQ = q;
      timer = setTimeout(function () { fetchNow(q); }, DEBOUNCE);
    });

    input.addEventListener('keydown', function (e) {
      if (box.hidden || !items.length) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault(); cursor = (cursor + 1) % items.length; highlight();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault(); cursor = (cursor - 1 + items.length) % items.length; highlight();
      } else if (e.key === 'Enter') {
        // Chưa chọn dòng nào thì để form submit như bình thường
        if (cursor >= 0) { e.preventDefault(); items[cursor].click(); }
      } else if (e.key === 'Escape') {
        close();
      }
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN && box.innerHTML) open();
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });
  }

  function init() {
    document.querySelectorAll('.egr-hd__search').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
